module.exports = __webpack_public_path__ + "img/thumbnail_006.c406d667.png";